import { HazardBaseLayer } from "./HazardBaseLayer";
import {
  getHazardLayerProps,
  type HazardLayerConfig,
} from "@/features/map/utils/hazardLayerUtils";

interface Props {
  year: number;
  defaultVisible: boolean;
  visible?: boolean;
}

const host = process.env.VITE_HAZARD_TILE_HOST ?? "";

export const FLOOD_30_LAYER_NAME = "浸水継続時間（想定最大規模）";

const layerConfig: HazardLayerConfig = {
  layerName: FLOOD_30_LAYER_NAME,
  yearConfigs: {
    2023: {
      url: `${host}/30/flood_30.pmtiles`,
      dataLayer: "4326_merged",
    },
    2024: {
      url: `${host}/30/2024_flood_30.pmtiles`,
      dataLayer: "2024_flood_30",
    },
    // 将来 2025年などが増えた場合はここに行を追加する
  },
};

const colorMap: Record<number, string> = {
  1: "rgb(165,212,254)",
  2: "rgb(13,75,254)",
  3: "rgb(250,246,14)",
  4: "rgb(252,157,11)",
  5: "rgb(255,51,14)",
  6: "rgb(182,12,108)",
  7: "rgb(104,14,104)",
};
const attributeKey = "A31b_301";

/*
浸水継続時間（想定最大規模）レイヤー
タイル元データ: 洪水浸水想定区域データ（1次メッシュ単位）2023年度, 2024年度
https://nlftp.mlit.go.jp/ksj/gml/datalist/KsjTmplt-A31b-2023.html
https://nlftp.mlit.go.jp/ksj/gml/datalist/KsjTmplt-A31b-2024.html
*/
export const HazardFlood30Layer: React.FC<Props> = ({
  defaultVisible,
  year,
  visible,
}) => {
  const layerProps = getHazardLayerProps(year, layerConfig);
  if (layerProps) {
    const { url, layerName, dataLayer } = layerProps;
    return (
      <HazardBaseLayer
        defaultVisible={defaultVisible}
        layerName={layerName}
        dataLayer={dataLayer}
        url={url}
        attributeKey={attributeKey}
        colorMap={colorMap}
        visible={visible}
      />
    );
  }
  return null;
};
